var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEnroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 19.5C19.0001 20.8807 17.8808 22 16.5001 22C15.1193 22 14.0001 20.8807 14.0001 19.5C14.0001 18.1193 15.1193 17 16.5001 17C17.8808 17 19.0001 18.1193 19.0001 19.5Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 19.5C30.0001 20.8807 28.8808 22 27.5001 22C26.1193 22 25.0001 20.8807 25.0001 19.5C25.0001 18.1193 26.1193 17 27.5001 17C28.8808 17 30.0001 18.1193 30.0001 19.5Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57993 17.6328L8.1573 17.8285C9.02431 14.0543 12.4473 11 16.4847 11H27.4847C32.1791 11 35.9847 14.8056 35.9847 19.5C35.9847 24.1944 32.1791 28 27.4847 28H17.3418C16.5134 28 15.8418 28.6716 15.8418 29.5C15.8418 30.3284 16.5134 31 17.3418 31H27.4847C33.836 31 38.9847 25.8513 38.9847 19.5C38.9847 13.1487 33.836 8 27.4847 8H16.4847C10.8391 8 6.14366 12.0682 5.16995 17.4329L6.57993 17.6328Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16995 17.6328C8.16995 18.4612 7.49838 19.1328 6.66995 19.1328C5.84153 19.1328 5.16995 18.4612 5.16995 17.6328C5.16995 16.8044 5.84153 16.1328 6.66995 16.1328C7.49838 16.1328 8.16995 16.8044 8.16995 17.6328Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98258 22.4275C6.98258 21.6028 8.06908 21.1898 8.70452 21.773L13.6871 26.3455C14.0811 26.707 14.0811 27.293 13.6871 27.6545L8.70452 32.227C8.06908 32.8102 6.98258 32.3972 6.98258 31.5725V22.4275Z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50006 25.5C10.3285 25.5 11.0001 26.1716 11.0001 27C11.0001 27.8284 10.3285 28.5 9.50006 28.5H2.50006C1.67163 28.5 1.00006 27.8284 1.00006 27C1.00006 26.1716 1.67163 25.5 2.50006 25.5H9.50006Z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnroll);
export default __webpack_public_path__ + "static/media/iconEnroll.19eee4fc.svg";
export { ForwardRef as ReactComponent };